import { LoginButton } from "../../components/LoginButton";

interface Props {
    isLoadingAuth?: boolean;
}

const LoginPage = ({ isLoadingAuth = false }: Props) => {
    const isScreeningUrl = window.location.pathname === '/screening'
    return (
        <div className={`${isScreeningUrl ? "worldcheck-background " : "login-background "}relative w-screen h-screen overflow-hidden`}>
            <div className="absolute top-[61%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 align-center z-[1]">
                <LoginButton disabled={isLoadingAuth} />
            </div>
        </div>
    );
};

export default LoginPage;
